<template>
  <div>
    <div class="inline-block pr-4 pb-4 w-1/2">
      <p
        class="align-top font-semibold font-sans leading-snug subpixel-antialiased text-base text-black"
      >
        {{ label }}
      </p>
    </div>
    <div class="inline-block pb-4 w-1/2">
      <p
        v-if="value"
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base text-black"
      >
        {{ day }}/{{ month }}/{{ year }}
      </p>
      <p
        v-else
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base"
      >
        Not provided
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoeCellDate",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    value: {
      type: Number
    }
  },
  data() {
    return {
      year: "",
      month: "",
      day: ""
    };
  },
  mounted() {
    if (typeof this.value !== "undefined") {
      let d = new Date(this.value);
      this.year = d.getFullYear();
      this.month = d.getMonth() + 1;
      this.day = d.getDate();
    }
  }
};
</script>

<style lang="scss" scoped></style>
